import { lazy } from 'react'

const FactionRoutes = [

  {
    path: '/factions/asset-charts',
    component: lazy(() => import('../../views/factions/asset-charts')),
    title: 'Asset Charts'
  },
  {
    path: '/factions/mud-assets',
    component: lazy(() => import('../../views/factions/mud-assets')),
    title: 'MUD Assets'
  },
  {
    path: '/factions/ustur-assets',
    component: lazy(() => import('../../views/factions/ustur-assets')),
    title: 'USTUR Assets'
  },
  {
    path: '/factions/oni-assets',
    component: lazy(() => import('../../views/factions/oni-assets')),
    title: 'ONI Assets'
  }

]

export default FactionRoutes
